















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import dayjs from 'dayjs'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'

@Component({
  components: {
    DateTooltipped
  }
})
export default class ContentItemDeliverAt extends Vue {
  @Prop() isoDate: string | null

  private get getDayJsInstance() {
    return dayjs(this.isoDate)
  }

  private get shorthand() {
    const now = dayjs()

    if (this.getDayJsInstance.isSame(now, 'd')) {
      return {
        color: 'text-tes-green',
        expression: 'امروز'
      }
    }

    if (this.getDayJsInstance.isSame(now.add(1, 'd'), 'd')) {
      return {
        color: 'text-tes-blue',
        expression: 'فردا'
      }
    }

    if (this.getDayJsInstance.isSame(now.subtract(1, 'd'), 'd')) {
      return {
        color: 'text-tes-red',
        expression: 'دیروز'
      }
    }

    return null
  }
}
